export default "__VITE_ASSET__DvfrgkXX__"